<template>
  <keep-alive include="marketingMerchantsList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "MarketingMerchants",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
